import React from 'react';
import styles from './index.module.css';

const AboutPage = () => {
	return (
		<div className={styles.container}>
			<h2>About Us</h2>
			<div>
			<section className={styles.card}>
          <h3>About Defying</h3>
          <p>
            Our team's main focus is to remove the middle
            discrepancies for which the temparing of data is stopped
            or hacking of the data is removed. This Decentralized
            Blockchain technology for voting is the way for decision
            making in the future.
          </p>
        </section>

        <section className={styles.card}>
          <h3>About Ovet</h3>
          <p>
            A blockchain oriented voting platform which stores data
            in Solana blockchain to engage people in a trust-worthy
            environment to make decision that is not baised or
            changed.
          </p>
        </section>

        <section className={styles.card}>
          <h3>Info</h3>
          <p>
            Our application has many more scope and can be used in
            many sectors and can be utilized in any decision making
            policies.
          </p>
        </section>

        <section className={styles.card}>
          <h3> Guidlines</h3>
          <p>
            This Decentralized Blockchain oriented platform is the
            solution for the future decision making in any field.
            Voter will be confirmed whether or not his/her vote is
            transferred to the correct canditate or party or
            policices.
          </p>
        </section>
			</div>
		</div>
	);
};

export default AboutPage;
